<template>
   <form class="needs-validation form-horizonta bv-form" enctype="multipart/form-data" @submit.stop.prevent="registerDsa">

      <button type="submit" class="bv-hidden-submit" style="display: none; width: 0px; height: 0px;"></button>
      <div class="col-md-12">
         <div class="row">
            <div class="col-md-6">
                <div class="form-group" >
                    <label for="name" class="col-form-label text-md-right">Name<sup class="mandatory_icon" title="Mandatory">*</sup></label>
                    <input id="name" type="text" class="form-control"
                    v-bind:class="{'is-invalid': veeErrors.first('name')}"
                    v-validate="'required'" data-vv-as="name"   v-model="form.name" name="name" value=""  autocomplete="name" autofocus="" data-bv-field="name">
                    <input type="hidden" name="_token" :value="form.csrf">
                    <span class="error">{{ veeErrors.first('name') }}</span>
                 </div>
            </div>
            <div class="col-md-6">
               <div class="form-group" >
                  <label for="representative_name" class="col-form-label text-md-right">Representative Name<sup class="mandatory_icon" title="Mandatory">*</sup></label>
                  <input id="representative_name" type="text" class="form-control"
                  v-bind:class="{'is-invalid': veeErrors.first('representative_name')}"
                  v-validate="'required'" data-vv-as="representative_name" v-model="form.representative_name"   name="representative_name" value=""  autocomplete="representative_name" autofocus="" data-bv-field="representative_name">
                  <span class="error">{{ veeErrors.first('representative_name') }}</span>
               </div>
            </div>
            <div class="col-md-12">
               <div class="row">
                  <div class="col-md-6">
                     <div class="col-md-12">
                        <div class="form-group" >
                           <label for="email" class="col-form-label text-md-right">E-Mail Address<sup class="mandatory_icon" title="Mandatory">*</sup></label>
                           <div class="input-group">
                              <input id="email" type="email"
                               v-bind:class="{'is-invalid': veeErrors.first('email')}"
                              v-model="form.email"  v-validate="'required|email'" data-vv-as="email"  placeholder="Email address" class="form-control" name="email">
                              <button class="btn btn-outline-secondary"  type="button" v-on:click="RequestOtp('email','dsa')">Get OTP</button>
                           </div>
                             <span class="error">{{ veeErrors.first('email') }}</span>
                        </div>
                     </div>

                  </div>
                  <div class="col-md-6">
                     <div class="col-md-12">
                        <div class="form-group" >
                           <label for="mobile" class="form-label">Mobile Number<sup class="mandatory_icon" title="Mandatory">*</sup></label>
                           <div class="input-group">
                              <div class="input-group-text">+91</div>
                              <input type="text"  name="mobile"
                               v-bind:class="{'is-invalid': veeErrors.first('mobile')}"
                               v-model="form.mobile" v-validate="'required'" data-vv-as="mobile"   placeholder="Mobile Number" class="form-control appearance_hide" >
                              <button class="btn btn-outline-secondary"  type="button" v-on:click="RequestOtp('mobile','dsa')" >Get OTP</button>
                           </div>
                           <span class="error">{{ veeErrors.first('mobile') }}</span>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div class="col-md-12">
               <div class="form-group" >
                  <label for="address" class="col-form-label text-md-right">Address<sup class="mandatory_icon" title="Mandatory">*</sup></label>
                  <textarea id="address" class="form-control " name="address"
                   v-bind:class="{'is-invalid': veeErrors.first('address')}"
                   v-model="form.address"  v-validate="'required'" data-vv-as="address"   autocomplete="address" autofocus="" data-bv-field="address"></textarea><i class="form-control-feedback" data-bv-icon-for="address" style="display: none;"></i>
                <span class="error">{{ veeErrors.first('address') }}</span>
               </div>
            </div>
            <div class="col-md-6">
               <div class="form-group" >
                  <label for="state_id" class="col-form-label text-md-right">State<sup class="mandatory_icon" title="Mandatory">*</sup></label>

                 <select
                    class="form-control"
                    name="state_id"
                    v-model="form.state_id"
                    v-bind:class="{'is-invalid': veeErrors.first('state_id')}"
                >
                    <option value="">Select State</option>
                    <option v-for="data in states.data" :key="data.id" :value="data.id">
                    {{ data.name }}
                    </option>
                </select>

                  <span class="error">{{ veeErrors.first('state_id') }}</span>
               </div>
            </div>
            <div class="col-md-6">
               <div class="form-group" >
                  <label for="city" class="col-form-label text-md-right">City<sup class="mandatory_icon" title="Mandatory">*</sup></label>
                  <input id="city" type="text" class="form-control"
                   v-bind:class="{'is-invalid': veeErrors.first('city')}"
                  name="city"  v-model="form.city"  data-vv-as="city"  autocomplete="city" autofocus="" data-bv-field="city">
                  <span class="error">{{ veeErrors.first('city') }}</span>
               </div>
            </div>
            <div class="col-md-6">
               <div class="form-group" >
                  <label for="pan_file" class="col-form-label text-md-right">Upload your PAN copy<sup class="mandatory_icon" title="Mandatory">*</sup></label>
                  <input id="pan_file" type="file" class="form-control"
                   v-bind:class="{'is-invalid': veeErrors.first('pan_file')}"
                   name="pan_file"    v-validate="'required|ext:jpeg,jpg,pdf,docx,dot,dotx'" data-vv-as="pan"  v-on:change="handleFileUpload('pan_file',$event)" autocomplete="pan_file" autofocus="" data-bv-field="pan_file" ><i class="form-control-feedback" data-bv-icon-for="pan_file" style="display: none;"></i>
                   <span class="error">{{ veeErrors.first('pan_file') }}</span>
               </div>
            </div>
            <div class="col-md-6">
               <div class="form-group" >
                  <label for="aadhar_file" class="col-form-label text-md-right">Upload your Aadhar copy<sup class="mandatory_icon" title="Mandatory">*</sup></label>
                  <input id="aadhar_file" type="file" class="form-control " name="aadhar_file"
                  v-bind:class="{'is-invalid': veeErrors.first('aadhar_file')}"
                  v-validate="'required|ext:jpeg,jpg,pdf,docx,dot,dotx'" data-vv-as="aadhar" v-on:change="handleFileUpload('aadhar_file',$event)"  autocomplete="aadhar_file" autofocus="" data-bv-field="aadhar_file"><i class="form-control-feedback" data-bv-icon-for="aadhar_file" style="display: none;"></i>
                  <span class="error">{{ veeErrors.first('aadhar_file') }}</span>
               </div>
            </div>
            <div class="col-md-6">
               <div class="form-group" >
                  <label for="business_proof_type" class="col-form-label text-md-right">Business Proof Type</label>
                  <input id="business_proof_type" type="text" class="form-control "
                    v-bind:class="{'is-invalid': veeErrors.first('business_proof_type')}"
                  name="business_proof_type"   autocomplete="business_proof_type" autofocus="" data-bv-field="business_proof_type">
                  <span class="error">{{ veeErrors.first('business_proof_type') }}</span>
               </div>
            </div>
            <div class="col-md-6">
               <div class="form-group" >
                  <label for="business_proof_file" class="col-form-label text-md-right">Business Proof File<sup class="mandatory_icon" title="Mandatory">*</sup></label>
                  <input id="business_proof_file" type="file" class="form-control " name="business_proof_file"
                   v-bind:class="{'is-invalid': veeErrors.first('business')}"
                   v-validate="'required'" data-vv-as="business proof" v-on:change="handleFileUpload('business_proof_file',$event)"  autocomplete="business_proof_file" autofocus="" data-bv-field="business_proof_file"><i class="form-control-feedback" data-bv-icon-for="business_proof_file" style="display: none;"></i>
                  <span class="error">{{ veeErrors.first('business_proof_file') }}</span>
               </div>
            </div>
            <div class="col-md-6">
               <div class="form-group" >
                  <label for="password" class="col-form-label text-md-right">Password<sup class="mandatory_icon" title="Mandatory">*</sup></label>
                  <input id="password" type="password" class="form-control " name="password"
                   v-bind:class="{'is-invalid': veeErrors.first('password')}"
                  v-validate="'required'" v-model="form.password" data-vv-as="password"  autocomplete="new-password" data-bv-field="password"><i class="form-control-feedback" data-bv-icon-for="password" style="display: none;"></i>
                  <span class="error">{{ veeErrors.first('password') }}</span>
               </div>
            </div>
            <div class="col-md-6">
               <div class="form-group" >
                  <label for="password-confirm" class="col-form-label text-md-right">Confirm Password<sup class="mandatory_icon" title="Mandatory">*</sup></label>
                  <input id="password-confirm" type="password" class="form-control" name="password_confirmation"
                  v-bind:class="{'is-invalid': veeErrors.first('password_confirmation')}"
                  v-model="form.password_confirmation"  v-validate="'required'" data-vv-as="confirmation password"    autocomplete="new-password" data-bv-field="password_confirmation"><i class="form-control-feedback" data-bv-icon-for="password_confirmation" style="display: none;"></i>
                  <span class="error">{{ veeErrors.first('password_confirmation') }}</span>
               </div>
            </div>
            <div class="col-md-12 text-end">
               <button type="submit" class="btn btn-primary">
               Register
               </button>
            </div>
         </div>
      </div>
   </form>
</template>

<script>

export default {
  name: "DsaReg",
  components: {

  },
  data() {
    return {

      states: [],
      form: {
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        name: "",
        state_id:1,
        representative_name: "",
        email: "",
        emailVerify:false,
        mobile: "",
        mobileVerify: false,
        address: "",
        city: "",
        pan_file: "",
        aadhar_file: "",
        business_proof_type: "",
        business_proof_file: "",
        password: "",
        password_confirmation: ""
      },
      allerros: [],
      success : false,
    };
  },
  created() {
    this.getStatus();
  },
  methods: {
    registerDsa(e) {

            this.$validator.validateAll().then((result) => {
                if (!result) {
                const el = document.querySelector(".is-invalid");
                el.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
                return;
                }
                if(result){

                        $(".preloader").show();
                        let formData = new FormData();
                        for(var k in this.form) {
                             formData.append(k,this.form[k] )
                        }
                        axios.post("register", formData,{ headers: {
                            'Content-Type': 'multipart/form-data'
                        }})
                        .then((response) => {

                           window.location.href='/business_partner/agreement';

                        })
                        .catch((error) => {
                            $(".preloader").hide();
                            this.allerros = error.response.data.errors;
                            this.success = false;
                        // handle error
                        this.errors = error.response.data.errors;
                        });
                }
            });

            // if (!this.veeErrors.any()) {

            // }


      e.preventDefault();
    },
    getStatus() {
        axios.get("/api/states")
        .then((response) => {
          this.states = response.data;
        })
        .catch((error) => {
          // handle error
          console.log(error);
        });
    },
    RequestOtp(type,subject){
        axios
        .get("/request-otp", {
          params: {
            type:type,
            subject:subject,
            type_value:(type=='email')?this.form.email:this.form.mobile
          },
        })
        .then((response) => {
         // response.data;
          otpBox();
        })
        .catch((error) => {
          // handle error
          console.log(error);
        });
    },
    handleFileUpload(file_name,event){
        if(file_name=='pan_file'){
            this.form.pan_file = event.target.files[0];
        }
        if(file_name=='aadhar_file'){
            this.form.aadhar_file = event.target.files[0];
        }
        if(file_name=='business_proof_file'){
            this.form.business_proof_file = event.target.files[0];
        }
      },
  },
};

</script>

